import React, { useEffect, useState } from 'react';
import {
  Dimensions,
  Keyboard,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  type KeyboardEvent,
} from 'react-native';
import { useTheme } from '../context/ThemeContext';

const TOOLBAR_HEIGHT = 44;

/** iOS Done bar above the keyboard — works globally without per-TextInput accessory IDs. */
const KeyboardDismissToolbar = () => {
  const { colors } = useTheme();
  const [visible, setVisible] = useState(false);
  const [bottom, setBottom] = useState(0);

  useEffect(() => {
    if (Platform.OS !== 'ios') {
      return;
    }

    const updateFromEvent = (event: KeyboardEvent) => {
      const windowHeight = Dimensions.get('window').height;
      const keyboardTop = event.endCoordinates.screenY;
      const offset = windowHeight - keyboardTop;

      if (offset > 0 && event.endCoordinates.height > 0) {
        setBottom(offset);
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    const showSub = Keyboard.addListener('keyboardWillChangeFrame', updateFromEvent);
    const hideSub = Keyboard.addListener('keyboardWillHide', () => setVisible(false));

    return () => {
      showSub.remove();
      hideSub.remove();
    };
  }, []);

  if (Platform.OS !== 'ios' || !visible) {
    return null;
  }

  return (
    <View pointerEvents="box-none" style={styles.container}>
      <View
        style={[
          styles.bar,
          {
            bottom,
            height: TOOLBAR_HEIGHT,
            backgroundColor: colors.surface,
            borderTopColor: colors.border,
          },
        ]}
      >
        <TouchableOpacity
          onPress={() => Keyboard.dismiss()}
          style={styles.doneButton}
          accessibilityRole="button"
          accessibilityLabel="Dismiss keyboard"
        >
          <Text style={[styles.doneText, { color: colors.brand.accent }]}>Done</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 10000,
    elevation: 10000,
  },
  bar: {
    position: 'absolute',
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderTopWidth: StyleSheet.hairlineWidth,
    paddingHorizontal: 12,
  },
  doneButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  doneText: {
    fontSize: 17,
    fontWeight: '600',
  },
});

export default KeyboardDismissToolbar;
